import {Component} from '@angular/core';

@Component({
  selector: 'app-docu-verifier',
  templateUrl: './docu-verifier.component.html',
  styleUrls: []
})
export class DocuVerifierComponent {}
